import "./index.css";
import Search from "./Search";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Search defaultCity="Vancouver" />
      </div>
    </div>
  );
}

export default App;
